import type { ReactNode } from "react";
import { DRAFT_BRANCH_ROUTE_PREFIX } from "../../shared/reservedRoutes";

const branchAddress = new RegExp(
  `^(.*?)(${DRAFT_BRANCH_ROUTE_PREFIX}/[\\w-]+|\\?branch=.*)(.*)$`
);

// Strips the scheme and fades the branch address so the route reads first.
export function UrlDisplay({ url }: { url: string }): ReactNode {
  const display = url.replace(/^https?:\/\//, "");
  const match = display.match(branchAddress);
  if (!match) return display;
  const [, before, branch, after] = match;
  return (
    <>
      {before}
      <span style={{ opacity: 0.4 }}>{branch}</span>
      {after}
    </>
  );
}
